/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Points_RtpInputs */



/**
* | output |
* | --- |
* | "RtP" |
*
* @param {League_Points_RtpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_points_rtp = /** @type {((inputs?: League_Points_RtpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Points_RtpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "es") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "pt") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "it") return /** @type {LocalizedString} */ ("RtP")
	return /** @type {LocalizedString} */ ("RtP")
});